import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgWishlistCss32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M22.2 2.7c-2.4 0-4.8 1.3-6.2 2.9-1.4-1.6-3.8-2.9-6.2-2.9-3 0-5.5 1.5-7.1 4.2-1.2 2-1.3 4.1-1.3 5 0 1.6.4 5.6 4.3 9.2 4 3.6 9.4 7.6 9.6 7.7l.7.5.7-.5c.2-.2 5.6-4.1 9.6-7.7 3.9-3.5 4.3-7.6 4.3-9.2 0-.8-.1-2.9-1.3-5-1.6-2.8-4.1-4.2-7.1-4.2z"
        className="wishlist-css-32_svg__fill"
      />
      <path
        d="M22.2 2.7c-2.4 0-4.8 1.3-6.2 2.9-1.4-1.6-3.8-2.9-6.2-2.9-3 0-5.5 1.5-7.1 4.2-1.2 2-1.3 4.1-1.3 5 0 1.6.4 5.6 4.3 9.2 4 3.6 9.4 7.6 9.6 7.7l.7.5.7-.5c.2-.2 5.6-4.1 9.6-7.7 3.9-3.5 4.3-7.6 4.3-9.2 0-.8-.1-2.9-1.3-5-1.6-2.8-4.1-4.2-7.1-4.2zm0 1.2c3.1 0 5 1.7 6.1 3.6s1.2 3.8 1.2 4.3.1 4.7-3.9 8.3c-4 3.6-9.5 7.7-9.5 7.7s-5.5-4-9.5-7.7c-4-3.6-3.9-7.8-3.9-8.3s.1-2.4 1.2-4.3C5 5.6 6.9 3.9 10 3.9s6 2.7 6 4.2c0-1.5 3-4.2 6.2-4.2z"
        className="wishlist-css-32_svg__border"
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgWishlistCss32);
export default Memo;
